module.exports = __webpack_public_path__ + "media/assets/images/plan02@2x-7a6e576a1414e90b3f967021bd8fc6db.png";